import React, { useState, useEffect } from 'react';
import { styled, ButtonChevron } from '@teko/ui';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Wrapper = styled.div`
  position: relative;
`;
const StyledButtonChevron = styled(ButtonChevron)`
  background: #fff;
  width: 100%;
  border: 1px solid #e0e0e0;
  line-height: unset;
  &:hover {
    background: #f3f3f3;
    border: 1px solid #e0e0e0;
  }
`;
const DropdownMenu = styled.div`
  position: absolute;
  width: 100%;
  top: 2rem;
  left: 0;
  z-index: 1000;
  border-radius: 4px;
  border: 1px solid #e0e0e0;
  overflow: hidden;
`;
const MiniDropdown = (_a) => {
  var _b = _a, {
    text,
    children
  } = _b, props = __objRest(_b, [
    "text",
    "children"
  ]);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [endDelay, setEndDelay] = useState(false);
  useEffect(() => {
    if (dropdownOpen) {
      setTimeout(() => {
        setEndDelay(true);
      }, 200);
    } else {
      setEndDelay(false);
    }
  }, [dropdownOpen, endDelay]);
  return /* @__PURE__ */ React.createElement(Wrapper, __spreadValues({
    onMouseEnter: () => setDropdownOpen(true),
    onMouseLeave: () => setDropdownOpen(false)
  }, props), /* @__PURE__ */ React.createElement(StyledButtonChevron, {
    direction: dropdownOpen ? "up" : "down"
  }, text), dropdownOpen && endDelay && /* @__PURE__ */ React.createElement(DropdownMenu, {
    onClick: () => setDropdownOpen(false)
  }, children));
};

export { MiniDropdown };
